import React from 'react';
import { motion } from 'framer-motion';
import { Thermometer, Sun } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-10 px-4 md:px-8 relative overflow-hidden" data-id="element-91">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-radial-cyan opacity-40 pointer-events-none" data-id="element-92" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-94">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-cyan-500/10 border border-cyan-500/20 text-cyan-400 text-sm font-semibold mb-6" data-id="element-95">
            EL MECANISMO ÚNICO
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-96">
            La Arquitectura Térmica y Lumínica
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} viewport={{
        once: true
      }} className="bg-[#0f1628]/50 backdrop-blur-sm border border-cyan-500/20 p-8 md:p-12 rounded-2xl shadow-2xl shadow-slate-900/30" data-id="element-97">
          <p className="text-lg md:text-xl text-gray-200 leading-relaxed mb-8" data-id="element-98">
            El Código del Sueño Profundo no usa químicos para "noquearte". En su
            lugar, manipulamos las dos variables evolutivas que controlan tu
            glándula pineal:{' '}
            <strong className="text-white" data-id="element-99">la luz y el calor</strong>.
          </p>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-100">
            <div className="flex gap-4" data-id="element-101">
              <div className="w-12 h-12 rounded-full bg-cyan-500/10 flex items-center justify-center shrink-0" data-id="element-102">
                <Thermometer className="w-6 h-6 text-cyan-400" data-id="element-103" />
              </div>
              <div data-id="element-104">
                <h3 className="font-bold text-white mb-2" data-id="element-105">
                  Enfriamiento Central
                </h3>
                <p className="text-[#b8c4d6] text-sm" data-id="element-106">
                  Al aprender a enfriar tu temperatura central, le indicas a tu
                  cuerpo que es hora de apagar los sistemas de alerta.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-107">
              <div className="w-12 h-12 rounded-full bg-cyan-500/10 flex items-center justify-center shrink-0" data-id="element-108">
                <Sun className="w-6 h-6 text-cyan-400" data-id="element-109" />
              </div>
              <div data-id="element-110">
                <h3 className="font-bold text-white mb-2" data-id="element-111">
                  Filtro de Espectro
                </h3>
                <p className="text-[#b8c4d6] text-sm" data-id="element-112">
                  Filtrar el espectro azul en momentos críticos obliga a tu
                  cuerpo a liberar su propia melatonina natural.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-slate-600/30 text-center" data-id="element-113">
            <p className="text-xl font-heading italic text-gray-200" data-id="element-114">
              "El sueño deja de ser algo que buscas y se convierte en algo
              inevitable."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}